import React from 'react'
import { ArticleCard, CardRow } from '@which/seatbelt'
import { ILatestNews } from '../../../data/shared/interfaces'

interface Props {
  latestNews: ILatestNews
}

const LatestNews = ({ latestNews }: Props): React.ReactElement => {
  const { className, latestNewsCards = [], link, title } = latestNews

  return (
    <div className="latest-news-wrapper full-bleed" data-testid="latest-news-wrapper">
      <span className="latest-news-row-head">Latest news in</span>
      <CardRow {...{ className, link, title }}>
        {latestNewsCards.map((item, index) => (
          <ArticleCard key={`latest-news-card-${index}`} {...item} />
        ))}
      </CardRow>
    </div>
  )
}

export default LatestNews
